import { Box, LinearProgress, Typography } from '@mui/material';
import * as React from 'react';
import { createElement } from 'react';

const CardWithIcon = props => {
  const {
    icon,
    title,
    percentage,
    target,
    value,
    color = 'primary',
    progressBar = false,
  } = props;
  const progress = percentage !== 'Infinity' ? percentage : 0;

  return (
    <Box display={'flex'} flexDirection={'column'} flex={1}>
      <Box display={'flex'} alignItems={'center'} gap={2}>
        <Box display={'flex'} alignItems={'center'} gap={1} flex={1}>
          {createElement(icon, { fontSize: 'medium', color: color })}
          <Typography fontSize={18} fontWeight="bold">
            {title}
          </Typography>
        </Box>
        {progressBar ? (
          <Typography component="span" fontSize={18} variant="h5">
            {`${progress}%`}
          </Typography>
        ) : null}
      </Box>

      <Typography
        component="p"
        fontSize={18}
        variant="h5"
        sx={{ marginTop: '14px' }}
      >
        <Typography
          component="span"
          fontSize={26}
          fontWeight="bold"
          variant="h5"
        >
          {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
            value
          )}
        </Typography>
        {target || target === 0 ? (
          <Typography
            component="span"
            fontSize={18}
            fontWeight="bold"
            color="#888888"
            variant="h5"
            sx={{ marginLeft: '4px' }}
          >
            /{' '}
            {Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(
              target
            )}
          </Typography>
        ) : null}
      </Typography>
      {progressBar ? (
        <LinearProgress
          variant="determinate"
          color={color}
          value={percentage >= 100 ? 100 : Number(percentage || 0)}
          sx={{
            height: 8,
            borderRadius: 5,
            [`& .MuiLinearProgress-bar`]: {
              borderRadius: 5,
            },
          }}
        />
      ) : null}
    </Box>
  );
};

export default CardWithIcon;
